import { compose } from 'recompose';
import { withLabelAlignmentStyles } from '@nextiva/engagement-ui';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import StylingToCSSLabelText from 'styling/hocs/StylingToCSS/StylingToCSSLabelText';
import propTypeStyleLabel from 'styling/config/editorBlock/PropTypes/styleLabel';

import MatrixCell from '../../layout/MatrixCell/MatrixCell';
import PlainText from '../../../../../PlainText/PlainText';
import styles from './MatrixAlignedCell.scss';

const MatrixAlignedCell = ({ className, styleLabel, ...rest }) => (
  <MatrixCell
    readOnly
    cellRenderer={PlainText}
    className={cx(className, styles.labelContainer)}
    styleCellRenderer={styleLabel}
    {...rest}
  />
);

MatrixAlignedCell.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  styleLabel: propTypeStyleLabel,
};

export default compose(
  StylingToCSSLabelText,
  withLabelAlignmentStyles,
)(MatrixAlignedCell);
